import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import NavBar from './NavBar';
import YogaLandingPage from './YogaLanding'
import ContactMePage from './YogaContactPage';
import Services from './YogaOfferingsPage';
import NatureFlowSignUp from './natureFlowSignUp';
import YogaSchedule from './yogaSchedule';


function App() {
  return (
    <BrowserRouter>
      <MainContent />
    </BrowserRouter>
  );
}

function MainContent() {
  const location = useLocation();

  return (
    <><div className="bg-[#FFF8F2]">
       <NavBar />
      <Routes>

        <Route path="/" element={<YogaLandingPage/>} />
        <Route path="/yoga" element={<YogaLandingPage />} />
        <Route path="/contact" element={<ContactMePage /> }/>
        <Route path="/services" element={<Services />} />
        <Route path="/nature-flow" element={<NatureFlowSignUp />}/>
        <Route path="/schedule" element={<YogaSchedule/>}/>
      </Routes></div>
    </>
  );
}


export default App;
